var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',{attrs:{"placement":"top-start","trigger":"click","title":"Danh sách: ","transition":"el-zoom-in-bottom"}},[_vm._t("default"),_vm._v(" "),_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_c('span',{staticClass:"highlight--name clickable tt-1"},[_vm._v("\n      "+_vm._s(_vm.word)+"\n    ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7abf58d5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/popover-word-2.vue
// module id = 4jiK
// module chunks = 89